<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      d="M4.97168 12C4.97168 8.13401 8.10568 5 11.9717 5C13.3415 5 14.4165 5.32722 15.3737 5.91476C15.8479 6.20581 16.3034 6.56697 16.7574 7H15C14.4477 7 14 7.44772 14 8C14 8.55228 14.4477 9 15 9H19C19.5523 9 20 8.55228 20 8V4C20 3.44772 19.5523 3 19 3C18.4477 3 18 3.44772 18 4V5.42327C17.5025 4.96269 16.9804 4.55425 16.4199 4.21024C15.137 3.42279 13.6978 3 11.9717 3C7.00112 3 2.97168 7.02943 2.97168 12C2.97168 16.9706 7.00112 21 11.9717 21C15.8919 21 19.2242 18.4941 20.4593 15C20.6434 14.4793 20.3705 13.9079 19.8498 13.7239C19.3291 13.5398 18.7577 13.8127 18.5737 14.3334C17.6122 17.0535 15.0179 19 11.9717 19C8.10568 19 4.97168 15.866 4.97168 12Z"
    />
  </svg>
</template>
